import type { ReactElement } from 'react';

import type {
  ButtonHtmlProps,
  DivHtmlProps,
  LinkHtmlProps,
  ObjectValues,
} from '../types';

export const sizes = {
  small: 'small',
  basic: 'basic',
  large: 'large',
} as const;

export const variants = {
  complete: 'complete',
  cta: 'cta',
  ctaSecondary: 'cta-secondary',
  ctaSecondaryWhite: 'cta-secondary-white',
  primary: 'primary',
  primaryDestructive: 'primary-destructive',
  primaryWhite: 'primary-white',
  secondary: 'secondary',
  secondaryWhite: 'secondary-white',
  secondaryDestructive: 'secondary-destructive',
  tertiary: 'tertiary',
  tertiaryDestructive: 'tertiary-destructive',
  fixedTertiary: 'fixed-tertiary',
  waitlist: 'waitlist',
  waitlistSecondary: 'waitlist-secondary',
} as const;

type CommonProps<ElementName extends string> = {
  className?: string;
  elementName: ElementName;
  hasStackedIcon?: boolean;
  iconOnly?: boolean;
  leadingIcon?: ReactElement;
  size?: ObjectValues<typeof sizes>;
  spinning?: boolean;
  testId?: string;
  text: string;
  trailingIcon?: ReactElement;
  variant?: ObjectValues<typeof variants>;
  wide?: boolean;
};

type Props<ElementProps, ElementName extends string> = ElementProps &
  CommonProps<ElementName>;

export type VisuallyButtonButton = Props<ButtonHtmlProps, 'button'>;
export type VisuallyButtonDiv = Props<DivHtmlProps, 'div'>;
export type VisuallyButtonLink = Props<LinkHtmlProps, 'a'> & { href: string };

export type VisuallyButton =
  | VisuallyButtonButton
  | VisuallyButtonDiv
  | VisuallyButtonLink;
